<template>
  <div class="MyAppsDetails"  v-loading="loading"
   >
    <el-row class="content_block mb30 p10">
      <div style="padding: 20px 0;color: #ffffff;font-size: 20px;font-weight: bold"> {{info.applicationName}} > 应用介绍
      </div>
      <div class="application_wrap">
        <div class="application_container">
          <div class="layui-carousel" id="banner" lay-anim="fade" lay-indicator="inside" lay-arrow="hover" style="width: 640px; height: 360px;">
              <el-carousel indicator-position="outside" height="340px" >
                <el-carousel-item v-for="item in imgList" :key="item">
                  <img :src="$isHttp(item)" style="width: 100%;height: 100%;"></img>
                </el-carousel-item>
              </el-carousel>
          </div>
          <div class="summary">
            <div class="head">
              <h6>{{info.applicationName}}</h6>
              <div class="score" id="star" data-number="3" title="gorgeous" style="width: 170px;">
                <span>评分：</span>
                <el-rate disabled style="float: right;margin-top: 6px;" v-model="value1"></el-rate>
              </div>
            </div>
              <p class="title">应用介绍：</p>
              <div class="content limit_line_five" v-html="info.applicationIntroduction"></div>
              <el-button type="primary" class="btn" @click="openNewWindow">进入应用</el-button>
          </div>
        </div>
      </div>
      <div class="guide">
          <div class="heading">
              <h5>实验系列指导</h5>
          </div>
          <div class="guide_item">
              <ul>
                  <li>
                      <a disabled @click="downLoadFile(info.applicationExperimentProgram, '实验大纲')" class="download">
                          <img src="../../images/apps/introduction_icon_outline.png">
                          <p>实验大纲</p>
                      </a>
                  </li>
                  <li>
                      <a @click="downLoadFile(info.applicationExperimentalCourse, '实验教程')" class="download">
                          <img src="../../images/apps/introduction_icon_course.png">
                          <p>实验教程</p>
                      </a>
                  </li>
                  <li>
                      <a @click="downLoadFile(info.applicationUserManual, '用户操作手册')" class="download">
                          <img src="../../images/apps/introduction_icon_manual.png">
                          <p>用户操作手册</p>
                      </a>
                  </li>
                  <li>
                      <a @click="downLoadFile(info.applicationInstallationPackage, '安装包')" class="download">
                          <img src="../../images/apps/introduction_icon_package.png">
                          <p>安装包</p>
                      </a>
                  </li>
              </ul>
          </div>
      </div>
      <div class="detail" deep="0">
        <div class="heading" id="applicationInfo">
            <h5>产品详细介绍</h5>
            <div style="color: #FFFFFF;" id="appContent" v-html="info.applicationInfo"></div>
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
import jQuery from "jquery";
export default {
  name: "MyAppsDetails",
  data() {
    return {
      resourcesApplicationId: this.$route.query.id,
      info: {
        realUrl:
          "http://tzcjbd.sztzjy.com/server/?resourcesApplicationId=2&key=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb2xsZWdlIjoi6YeP5YyW5oqV6LWEIiwicGFzc3dvcmQiOiIxMjNxd2UiLCJ0ZWFjaGVyaWQiOiIyIiwibWFqb3IiOiLph4_ljJbmipXotYQiLCJzY2hvb2wiOiLnmpbopb_lrabpmaIiLCJyb2xlaWQiOiIzIiwic2V4Ijoi55S3IiwibmFtZSI6IuS9n-iAgeW4iCIsInVzZXJuYW1lIjoi5L2f6ICB5biIIn0.08SJW-XGiYWtnpXMjd4JyDt4beoBQiHFw3thEDyA8ck",
        applicationName: "智能理财分析教学系统",
        applicationIntroduction:
          "系统为开设理财规划教材配套的实训软件，包含个人理财和家庭理财，包含现金规划、教育规划、养老规划、购房规划、自由梦想、购车规划、保险规划、财富传承与投资规划，投组动态管理等理财模块。",
      },
      value1: 5,
      imgList: [
        require("../../images/course/sf4.png"),
        require("../../images/course/sf3.png"),
      ],
      timeIn: null,
      loading: true, //加载状态
    };
  },
  created() {
    if (this.$isEmpty(this.resourcesApplicationId)) {
      this.$message({ message: "数据丢失！", type: "warning" });
      return;
    }
    this.loading = true; //开始加载
    this.getInfo();
    //this.addSystem();
  },
  mounted() {},
  methods: {
    getInfo() {
      this.$get("/api/resourcesApplication/getInfo.do", {
        resourcesApplicationId: this.resourcesApplicationId,
      }).then((ret) => {
        if (ret.code == 0) {
          this.loading = false;
          this.info = ret.data;
          this.$ls.set(this.$getKeyInfo("logName"), this.info.applicationName); //用于使用记录
          if (!this.$isEmpty(this.info.applicationInfo)) {
            this.info.applicationInfo = this.info.applicationInfo
              .replace(/&lt;/g, "<")
              .replace(/&gt;/g, ">");
          }
          if (!this.$isEmpty(ret.data.applicationCarousel)) {
            this.imgList = ret.data.applicationCarousel.split(",");
          }
          this.$forceUpdate();
          setTimeout(() => {
            let this_ = this;
            jQuery("#applicationInfo img").each(function () {
              let url = jQuery(this)
                .prop("src")
                .replace("http://localhost:8080/server", "");
              jQuery(this).prop("src", this_.$isHttp(url));
            });
          }, 500);
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    downLoadFile(url, name) {
      if (!this.$isEmpty(url)) {
        this.$downLoadFile(url, name);
      }
    },
    /**
     * 打开新窗口页面
     * @param item
     */
    openNewWindow() {
      if (!this.$isEmpty(this.info.realUrl)) {
        let userInfo = this.$ls.get(this.$getKeyInfo("userInfo")) || {};
        let JT_Sapps = ["数字发票", "数字供应链", "数字人民币"];
        if (userInfo.jobType1 == "JT_S_02") {
          if (JT_Sapps.includes(this.info.applicationSecondLevelRelation)) {
            window.open(
              this.info.realUrl.replace(
                /^(https?:\/\/[^\/]+)(.*)$/,
                `${"https://qkljr.sztzjy.com:89"}$2`
              )
            );
          } else {
            window.open(
              this.info.realUrl.includes("https://szjj.sztzjy.com:99/")
                ? this.info.realUrl.replace(
                    "https://szjj.sztzjy.com:99/",
                    "https://szjj.sztzjy.com:98/"
                  )
                : this.info.realUrl
            );
          }
        } else {
          window.open(this.info.realUrl);
        }
      }
    },
    addSystem() {
      //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get("timeNum"); //获取统一
      this.timeIn = setInterval(() => {
        let param = {
          firstName: "应用中心", //一级名称
          secondName: this.info.applicationName, //二级名称
          useDuration: timeNum / 1000 / 60, //单次使用时长（单位：分钟）
        };
        this.$addSystemUseLog(param);
      }, timeNum);
      // 结束
    },
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  },
};
</script>
 <style  lang="less" scoped>
 .el-loading-parent--relative .el-loading-spinner {
  top: 22% !important;
}

.MyAppsDetails {
  background-color: #383f4a;
  p {
    margin: 0;
  }
  a {
    text-decoration: none;
  }
  .download {
    cursor: pointer;
  }
  .content_block {
    width: 1260px;
    margin: 0 auto;
    background-color: #383f4a;
  }
  #applicationInfo {
    img {
      max-width: 100%;
    }
  }
  .layui-breadcrumb {
    display: block;
    margin-bottom: 20px;
  }

  .layui-breadcrumb a {
    color: #fff !important;
  }

  .layui-breadcrumb a cite {
    color: #fff;
  }

  .application_wrap {
    background-color: #4d5e7b;
    padding: 20px 0;
  }

  .application_container {
    width: 1200px;
    height: 400px;
    margin: 0 auto;
    padding: 20px 40px 20px 20px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
  }

  .application_container #banner {
    width: 640px;
    height: 360px;
    overflow: hidden;
  }

  .application_container #banner img {
    max-width: 100%;
  }

  .application_container #banner .layui-carousel-ind li.layui-this {
    width: 20px;
    border-radius: 20px;
    background-color: #3c76df;
  }

  .application_container #banner .layui-carousel-ind ul {
    background-color: rgba(0, 0, 0, 0);
  }

  .application_container .summary {
    width: 466px;
    height: 360px;
    float: right;
    padding: 40px 0 20px;
    box-sizing: border-box;
  }

  .summary .head {
    height: 32px;
    line-height: 32px;
    border-bottom: #ddd 1px solid;
    margin-bottom: 15px;
    overflow: hidden;
  }

  .summary .head h6 {
    font-size: 18px;
    float: left;
    color: #fff;
    margin: 0;
  }

  .summary .score {
    width: 144px;
    float: right;
  }

  .summary .score span {
    font-size: 14px;
    color: #fff;
  }

  .summary .score img {
    margin-top: -5px;
  }

  .summary .title {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #fff;
  }

  .summary .heading {
    margin-top: 38px;
  }

  .summary .content {
    line-height: 30px;
    height: 144px;
    text-overflow: ellipsis;
    -webkit-line-clamp: 5;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #fff;
  }

  .summary .btn {
    width: 168px;
    height: 40px;
    box-sizing: border-box;
    float: right;
    padding: 0;
    background-image: linear-gradient(0deg, #4d8cfd 0%, #4d8cfd 100%),
      linear-gradient(#3c76df, #3c76df);
    background-blend-mode: normal, normal;
    border-radius: 5px;
    margin-top: 40px;
  }

  .heading {
    margin: 40px auto;
    text-align: center;
  }

  .heading h5 {
    height: 24px;
    line-height: 24px;
    font-size: 20px;
    color: #fff;
    background: url(../../images/apps/title_bg1.png) left center no-repeat,
      url(../../images/apps/title_bg2.png) right center no-repeat;
    padding: 0 40px;
    display: inline-block;
  }

  .guide_item {
    width: 100%;
  }

  .guide_item ul {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .guide_item ul li {
    list-style: none;
  }
  .guide_item ul li a {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .guide_item ul li a p {
    color: #4e74ae;
    line-height: 24px;
    font-size: 14px;
  }

  .detail {
    width: 1200px;
    margin: 0 auto;
  }

  .detail .text {
    color: #fff;
    font-size: 16px;
    line-height: 26px;
    text-indent: 2em;
  }

  .detail .process {
    display: flex;
    justify-content: space-between;
    margin: 30px 0;
  }

  .detail .process li {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .detail .process .icon {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .detail .process li:nth-child(odd) .icon {
    background-color: #cccccc;
  }

  .detail .process li:nth-child(even) .icon {
    background-color: #e1c6fb;
  }

  .detail .process li:nth-child(odd) .shape {
    margin: 20px 0 10px 0;
  }

  .detail .process li:nth-child(even) .shape {
    margin: 10px 0 20px 0;
  }

  .detail .process p {
    width: 128px;
    height: 90px;
    line-height: 28px;
    font-size: 16px;
    text-align: center;
    color: #fff;
  }

  .detail .process li:nth-child(even) p {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  .detail section {
    margin-bottom: 30px;
    overflow: hidden;
  }

  .detail h6 {
    font-size: 18px;
    color: #fff;
    text-indent: 2em;
    margin-bottom: 10px;
  }

  .detail .image {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .detail .image img {
    max-width: 100%;
  }

  .detail .course {
    width: 900px;
    margin: 34px auto;
  }

  .detail .course,
  .detail .course thead tr,
  .detail .course tr:hover {
    background-color: rgba(0, 0, 0, 0) !important;
  }

  .detail .course td,
  .detail .course th {
    text-align: center;
    border-width: 2px;
    border-color: #fff;
    color: #fff;
  }

  .detail .course td {
    font-size: 16px;
    padding: 42px 0;
  }

  .detail .course td p {
    line-height: 30px;
  }

  .detail .course th {
    height: 56px;
    font-size: 18px;
    box-sizing: border-box;
  }

  .detail img {
    max-width: 100%;
    margin: 10px 0;
  }
  @media screen and (max-width: 1200px) {
    .guide_item {
      width: 1200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/myApps/MyAppsDetails.vue